import { useEffect, useMemo, useState } from "react";
import { Slider, Box, Typography } from "@mui/material";

export default function FilterPriceRange({
                                             min = 0,
                                             max = 3000,
                                             value,
                                             onChange,
                                         }) {
    const safeMin = Number(min ?? 0);
    const safeMax = Number(max ?? 0);

    const resolvedValue = useMemo(() => {
        const isValidArray =
            Array.isArray(value) &&
            value.length === 2 &&
            value.every((v) => typeof v === "number" && !Number.isNaN(v));

        let next = isValidArray ? [...value] : [safeMin, safeMax];

        next[0] = Math.max(safeMin, Math.min(next[0], safeMax));
        next[1] = Math.max(safeMin, Math.min(next[1], safeMax));

        if (next[0] > next[1]) {
            next = [safeMin, safeMax];
        }

        // αν έρθει [0,0] ή ίδια τιμή ενώ υπάρχει κανονικό εύρος,
        // ξεκίνα σωστά από min-max
        if (next[0] === next[1] && safeMin !== safeMax) {
            next = [safeMin, safeMax];
        }

        return next;
    }, [value, safeMin, safeMax]);

    const [localValue, setLocalValue] = useState([safeMin, safeMax]);

    useEffect(() => {
        setLocalValue(resolvedValue);
    }, [resolvedValue]);

    const step =
        Number.isInteger(safeMin) && Number.isInteger(safeMax) ? 1 : 0.1;

    const formatPrice = (num) =>
        `${new Intl.NumberFormat("el-GR", {
            minimumFractionDigits: Number.isInteger(num) ? 0 : 1,
            maximumFractionDigits: 1,
        }).format(num)} €`;

    return (
        <Box>
            <Slider
                value={localValue}
                min={safeMin}
                max={safeMax}
                step={step}
                disableSwap
                onChange={(_, newValue) => {
                    if (!Array.isArray(newValue)) return;
                    setLocalValue(newValue);
                }}
                onChangeCommitted={(_, newValue) => {
                    if (!Array.isArray(newValue)) return;
                    onChange?.(newValue[0], newValue[1]);
                }}
                valueLabelDisplay="auto"
                valueLabelFormat={(v) => formatPrice(v)}
                sx={{
                    color: "#111",
                    "& .MuiSlider-thumb": {
                        width: 15,
                        height: 15,
                        bgcolor: "#111",
                    },
                    "& .MuiSlider-rail": {
                        opacity: 0.4,
                    },
                }}
            />

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "120%",
                        fontFamily: "Zen Maru Gothic",
                    }}
                >
                    {formatPrice(safeMin)}
                </Typography>

                <Typography
                    variant="caption"
                    sx={{
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "120%",
                        fontFamily: "Zen Maru Gothic",
                    }}
                >
                    {formatPrice(safeMax)}
                </Typography>
            </Box>
        </Box>
    );
}